import { render, staticRenderFns } from "./FileViewerVideo.vue?vue&type=template&id=7d84c81c&"
import script from "./FileViewerVideo.vue?vue&type=script&lang=ts&"
export * from "./FileViewerVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports